import React, { useState, useEffect } from 'react';
import './FloatingWhatsapp.css';

const FloatingWhatsapp = ({
    phone = "51999999999",
    size = '60px',
    backgroundColor = '#25D366',
    buttonImage = '/whatsapp.png',
    defaultMessage = 'Hola, quiero información'
}) => {

    const [showNotif, setShowNotif] = useState(false);
    const [showOffer, setShowOffer] = useState(true);
    const [collapsed, setCollapsed] = useState(false);
    const [confetti, setConfetti] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setShowNotif(true);

            setTimeout(() => {
                setShowNotif(false);
            }, 5000);

        }, 10000);

        return () => clearInterval(interval);
    }, []);

    // 🎁 CONFETI CADA 8 SEGUNDOS
    useEffect(() => {
        const confettiInterval = setInterval(() => {
            setConfetti(true);

            setTimeout(() => {
                setConfetti(false);
            }, 1500);

        }, 8000);

        return () => clearInterval(confettiInterval);
    }, []);

    const sendWhatsappMessage = () => {
        const whatsappLink = `https://wa.me/${phone}?text=${encodeURIComponent(defaultMessage)}`;
        window.open(whatsappLink, '_blank');
    };

    const closeOffer = () => {
        setShowOffer(false);
        setCollapsed(true);
    };

    const openOffer = () => {
        setShowOffer(true);
        setCollapsed(false);
    };

    return (
        <>
            {/* 🔥 PROMO */}
            {showOffer && (
                <div className="promo-big">

                    {/* ❌ cerrar */}
                    <button className="close-btn" onClick={closeOffer}>✖</button>

                    {/* 🎁 contenido */}
                    <div className="promo-content" onClick={sendWhatsappMessage}>
                        🎁 Aprovecha nuestras ofertas 🔥
                    </div>

                    {/* 🎁 CAJITA ANIMADA */}
                    <div className="gift-box">🎁</div>

                    {/* 🎉 CONFETI */}
                    {confetti && (
                        <div className="confetti-container">
                            {Array.from({ length: 20 }).map((_, i) => (
                                <span key={i} className="confetti"></span>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {/* ⬆️ FLECHA */}
            {collapsed && (
                <div className="promo-collapsed" onClick={openOffer}>
                    ↑
                </div>
            )}

            {/* 💬 WHATSAPP */}
            <div className="floating-container">

                {showNotif && (
                    <div className="notif-bubble shake">
                        Hola 👋, ¿Como podemos ayudarte?
                    </div>
                )}

                <div
                    className={`floating-button ${showNotif ? 'active' : ''}`}
                    onClick={sendWhatsappMessage}
                    style={{ width: size, height: size, backgroundColor }}
                >
                    <img src={buttonImage} alt="WhatsApp" />
                    {showNotif && <div className="badge">1</div>}
                </div>

            </div>
        </>
    );
};

export default FloatingWhatsapp;